import { render, staticRenderFns } from "./rdms.vue?vue&type=template&id=7812ea52&scoped=true"
import script from "./rdms.vue?vue&type=script&lang=js"
export * from "./rdms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7812ea52",
  null
  
)

export default component.exports